/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BaseCommand model module.
 * @module model/BaseCommand
 * @version 1.1.0
 */
class BaseCommand {
    /**
     * Constructs a new <code>BaseCommand</code>.
     * Base schema shared by command types
     * @alias module:model/BaseCommand
     */
    constructor() { 
        
        BaseCommand.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BaseCommand</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BaseCommand} obj Optional instance to populate.
     * @return {module:model/BaseCommand} The populated <code>BaseCommand</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BaseCommand();

            if (data.hasOwnProperty('duration')) {
                obj['duration'] = ApiClient.convertToType(data['duration'], 'String');
            }
            if (data.hasOwnProperty('timeCommanded')) {
                obj['timeCommanded'] = ApiClient.convertToType(data['timeCommanded'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BaseCommand</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BaseCommand</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['duration'] && !(typeof data['duration'] === 'string' || data['duration'] instanceof String)) {
            throw new Error("Expected the field `duration` to be a primitive type in the JSON string but got " + data['duration']);
        }

        return true;
    }


}



/**
 * Duration in ISO-8601 format
 * @member {String} duration
 */
BaseCommand.prototype['duration'] = undefined;

/**
 * The time which the command was made
 * @member {Date} timeCommanded
 */
BaseCommand.prototype['timeCommanded'] = undefined;






export default BaseCommand;

